"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSubsidyForOffer = getDefaultSubsidyForOffer;
const constants_1 = require("@daytrip/constants");
const MIN_HOURS_TO_APPLY_DISCOUNT = 36;
const MIN_DRIVERS_TO_APPLY_DISCOUNT = 3;
const MAX_CONSIDERED_ASSIGNATION_DAYS = 21;
function getDefaultSubsidyForOffer(options) {
    if (shouldSkipAdditionalSubsidy(options)) {
        return options.additionalDiscount ? Math.round(options.vehiclePrice * options.additionalDiscount * -1) : 0;
    }
    const earlyAssignationSubsidy = getEarlyAssignationSubsidy(options);
    const withEarlyAssignationSubsidy = options.vehiclePrice + earlyAssignationSubsidy;
    const tripDurationSubsidy = getTripDurationSubsidy({ ...options, vehiclePrice: withEarlyAssignationSubsidy });
    const withSmartAssignationSubsidies = options.vehiclePrice + earlyAssignationSubsidy + tripDurationSubsidy;
    const additionalSubsidy = options.additionalDiscount ? withSmartAssignationSubsidies * options.additionalDiscount * -1 : 0;
    return Math.round(earlyAssignationSubsidy + tripDurationSubsidy + additionalSubsidy);
}
function shouldSkipAdditionalSubsidy(options) {
    const tripDurationMinutes = options.tripDurationInMinutes ?? 0;
    const tripDurationHours = tripDurationMinutes / constants_1.HOUR_IN_MINUTES;
    const pricePerHour = options.vehiclePrice / tripDurationHours;
    // In the case of trip consting less than 20€/$ per hour (countries cheaper than Mexico), no subsidy should be applied
    const NOT_DISCOUNTABLE_PER_HOUR_COMPENSATION = 20;
    return tripDurationMinutes && pricePerHour < NOT_DISCOUNTABLE_PER_HOUR_COMPENSATION;
}
function getEarlyAssignationSubsidy({ vehiclePrice, fittingDriversCount, departureAtUtc, baseDiscount, earlyAssignationDiscount, }) {
    const hoursToDeparture = (departureAtUtc.getTime() - Date.now()) / constants_1.HOUR_IN_MILLISECONDS;
    if (fittingDriversCount < MIN_DRIVERS_TO_APPLY_DISCOUNT || hoursToDeparture < MIN_HOURS_TO_APPLY_DISCOUNT) {
        return 0;
    }
    const maxConsideredAssignationTime = constants_1.DAY_IN_HOURS * MAX_CONSIDERED_ASSIGNATION_DAYS;
    const assignedInAdvanceInHours = Math.min(hoursToDeparture, maxConsideredAssignationTime);
    const assignedInAdvanceCoefficient = (assignedInAdvanceInHours - MIN_HOURS_TO_APPLY_DISCOUNT) / (maxConsideredAssignationTime - MIN_HOURS_TO_APPLY_DISCOUNT);
    const subsidy = baseDiscount + assignedInAdvanceCoefficient * earlyAssignationDiscount;
    const subsidyPercentage = (subsidy * getEarlyAssignationSubsidyMultiplier(fittingDriversCount)) / 100;
    return subsidyPercentage * vehiclePrice * -1;
}
// Scale subsidy multiplier linearly from 0 (2 drivers) to 1 (8+ drivers)
function getEarlyAssignationSubsidyMultiplier(fittingDriversCount) {
    if (fittingDriversCount < MIN_DRIVERS_TO_APPLY_DISCOUNT) {
        return 0;
    }
    else if (fittingDriversCount >= 8) {
        return 1;
    }
    else {
        return (fittingDriversCount - 2) / 6;
    }
}
const NO_DISCOUNT_DURATION_HOURS_THRESHOLD = 3;
const MAX_TRIP_DURATION_DISCOUNT_HOURS = 10;
const DISCOUNTED_TIME_RANGE_HOURS = MAX_TRIP_DURATION_DISCOUNT_HOURS - NO_DISCOUNT_DURATION_HOURS_THRESHOLD;
// Experiment details https://ondaytrip.slack.com/archives/C0359PLNKR8/p1727939652202699
function getTripDurationSubsidy({ vehiclePrice, tripDurationInMinutes, tripDurationDiscountMax }) {
    if (!tripDurationInMinutes) {
        return 0;
    }
    const tripDurationHours = tripDurationInMinutes / constants_1.HOUR_IN_MINUTES;
    if (tripDurationHours <= NO_DISCOUNT_DURATION_HOURS_THRESHOLD) {
        return 0;
    }
    // Apply discount, that increases linearly from 3 to 10 hours, above 10 hours we apply the maximum discount
    const discountedHours = Math.min(tripDurationHours, MAX_TRIP_DURATION_DISCOUNT_HOURS) - NO_DISCOUNT_DURATION_HOURS_THRESHOLD;
    const discountCoeffiecient = discountedHours / DISCOUNTED_TIME_RANGE_HOURS;
    const tripLengthCoefficient = (tripDurationDiscountMax * discountCoeffiecient) / 100;
    return vehiclePrice * tripLengthCoefficient * -1;
}
//# sourceMappingURL=getDefaultSubsidyForOffer.js.map